module.exports = __webpack_public_path__ + "static/media/Ex1-S6.60e8eb1e.PNG";